import React from 'react';
import PropTypes from "prop-types";
import axios from 'axios';
import Spinner from "../../../qwc2/components/widgets/Spinner";
import LocaleUtils from "../../../qwc2/utils/LocaleUtils";
import AbstractTab from "./AbstractTab";
import {connect} from "react-redux";
import {addDetailWindow, removeDetailWindow, setDetailWindow} from "../../actions/details";
import {setDirty} from "../../actions/dirty";
import FeatureUtils from "../../utils/FeatureUtils";
import cloneDeep from "lodash/cloneDeep";

export class FormTab extends AbstractTab {

    static propTypes = {
        addDetailWindow: PropTypes.func,
        feature: PropTypes.object,
        removeDetailWindow: PropTypes.func,
        setDetailWindow: PropTypes.func,
        setDirty: PropTypes.func,
        tab: PropTypes.object,
        windowId: PropTypes.string,
        windowType: PropTypes.string
    }

    static defaultProps = {
        feature: {},
        tab: {},
        windowId: ''
    }

    constructor(props) {
        super(props);

        this.state = {
            data: {},
            lists: {},
            info: '',
            isLoading: true,
            uploading: false,
            autocomplete: {}
        };
    }

    getConfig() {
        return this.props.tab.config;
    }

    getUrl() {
        return this.props.tab.url;
    }

    componentDidMount() {
        const self = this;
        const formData = {};
        let loadAny = false;
        this.getConfig().fields.forEach(field => {
            if (field.type === 'geometry') {
                // purely presentational - it never has a value in state.data, see FeatureformTab.renderField
                return;
            }
            formData[field.name] = null;

            if (this.getConfig().data) {
                const value = FeatureUtils.resolveValue(this.getConfig().data, field.name);
                //console.log('Resolve field falue', field.name, value);
                if (value !== undefined) {
                    formData[field.name] = value;
                }
            }

            // load options from urls
            if (field.options && typeof field.options === 'string' && field.type !== 'autocomplete') {
                const url = FeatureUtils.prepareUrl(this.props.feature, field.options);
                loadAny = true;
                axios(url).then(response => {
                    const lists = self.state.lists;
                    lists[field.name] = response.data;
                    self.setState({
                        lists: lists,
                        data: formData,
                        info: '',
                        isLoading: false
                    });
                }).catch(error => {
                    console.log("Error *** : " + error);
                });
            }
        });
        this.initialData = {...formData};

        if (!loadAny && this.state.isLoading) {
            self.setState({
                isLoading: false,
                data: formData
            });
        }

        // resolve the display label of any pre-selected autocomplete value
        this.getConfig().fields.forEach(field => {
            if (field.type === 'autocomplete' && formData[field.name]) {
                this.loadAutocompleteLabel(field, formData[field.name]);
            }
        });
    }

    componentWillUnmount() {
        this.props.setDirty(this.props.windowId, false);
    }

    isDirty(data) {
        const initial = this.initialData || {};
        return Object.keys(data).some(k => data[k] !== initial[k]);
    }

    parseAutocompleteResponse(data) {
        const items = Array.isArray(data) ? data : (data.value || data.items || []);
        return items.map(item => ({label: item.title, value: item.const}));
    }

    loadAutocompleteLabel(field, value) {
        axios.get(field.options).then(response => {
            const match = this.parseAutocompleteResponse(response.data).find(item => item.value === value);
            if (match) {
                this.setState(prev => ({
                    autocomplete: {
                        ...prev.autocomplete,
                        [field.name]: {...prev.autocomplete[field.name], term: '', results: [], loading: false, label: match.label}
                    }
                }));
            }
        }).catch(error => {
            console.log("Error *** : " + error);
        });
    }

    searchAutocomplete(field, term) {
        this.setState(prev => ({
            autocomplete: {
                ...prev.autocomplete,
                [field.name]: {...prev.autocomplete[field.name], term: term}
            }
        }));

        clearTimeout(this.autocompleteTimers && this.autocompleteTimers[field.name]);
        this.autocompleteTimers = this.autocompleteTimers || {};

        if (term.trim().length < 3) {
            this.setState(prev => ({
                autocomplete: {
                    ...prev.autocomplete,
                    [field.name]: {...prev.autocomplete[field.name], results: [], loading: false}
                }
            }));
            return;
        }

        this.autocompleteTimers[field.name] = setTimeout(() => this.fetchAutocomplete(field, term), 300);
    }

    fetchAutocomplete(field, term) {
        this.setState(prev => ({
            autocomplete: {
                ...prev.autocomplete,
                [field.name]: {...prev.autocomplete[field.name], loading: true}
            }
        }));
        const url = field.options + '?searchTerm=' + encodeURIComponent(term);
        axios.get(url).then(response => {
            const results = this.parseAutocompleteResponse(response.data);
            this.setState(prev => ({
                autocomplete: {
                    ...prev.autocomplete,
                    [field.name]: {...prev.autocomplete[field.name], results: results, loading: false}
                }
            }));
        }).catch(error => {
            console.log("Error *** : " + error);
            this.setState(prev => ({
                autocomplete: {
                    ...prev.autocomplete,
                    [field.name]: {...prev.autocomplete[field.name], loading: false}
                }
            }));
        });
    }

    selectAutocompleteValue(field, item) {
        this.setFieldValue(field, item.value);
        this.setState(prev => ({
            autocomplete: {
                ...prev.autocomplete,
                [field.name]: {term: '', results: [], loading: false, label: item.label}
            }
        }));
    }

    clearAutocompleteValue(field) {
        this.setFieldValue(field, '');
        this.setState(prev => ({
            autocomplete: {
                ...prev.autocomplete,
                [field.name]: {term: '', results: [], loading: false, label: null}
            }
        }));
    }

    render() {
        return (
            <div className="feature-details-fileupload">
                {this.state.isLoading &&
                    <div>
                        <Spinner/>
                        <div>{LocaleUtils.tr("attribtable.loading")}</div>
                    </div>
                }
                {!this.state.isLoading &&
                    <div>
                        {this.renderForm()}
                    </div>
                }
            </div>
        );
    }

    setFieldValue(field, value) {
        const data = this.state.data;
        if (field.type === 'file') {
            //console.log('File', field.name, value);
            if (value[0]) {
                const fileReader = new FileReader();
                /*fileReader.onloadend = () => {
                    data[field.name] = {
                        content: fileReader.result,
                        name: value[0].name
                    };
                    console.log('File loaded', fileReader.result);
                    this.setState({data: data});
                };
                fileReader.readAsText(value[0]);*/
                data[field.name] = value[0];
            } else {
                data[field.name] = '';
            }
        } else {
            data[field.name] = value;
        }
        this.setState({data: data});
        this.props.setDirty(this.props.windowId, this.isDirty(data));
    }

    selectValue(value) {
        if (value === null || typeof value === 'undefined') {
            return '';
        }
        return value;
    }

    resolveOptionValue(field, rawValue) {
        const option = this.getOptions(field).find(item => String(item.value) === rawValue);
        return option ? option.value : rawValue;
    }

    getOptions(field) {
        if (Array.isArray(field.options)) {
            return field.options;
        } else {
            const list = [];
            const fieldName = field.name;
            if (this.state.lists[fieldName]) {
                console.log('Building options', this.state.lists);
                this.state.lists[fieldName].features.forEach(item => {
                    const label = item.properties.description || item.properties.name;
                    list.push({
                        label: label,
                        value: item.properties.id
                    });
                });
            }
            return list;
        }
    }

    renderField(field) {
        let input = null;
        const readonly = field.readonly || null;
        const required = this.isFieldRequired(field);
        switch (field.type) {
            case 'select':
                input = (
                    <select onChange={ev => this.setFieldValue(field, this.resolveOptionValue(field, ev.target.value))} readOnly={readonly}
                            value={this.selectValue(this.state.data[field.name])}>
                        {!required && <option value="">-</option>}
                        {this.getOptions(field).map(item => {
                            return (
                                <option key={item.label} value={item.value}>{item.label}</option>
                            );
                        })}
                    </select>
                );
                break;
            case 'autocomplete': {
                const autocompleteState = this.state.autocomplete[field.name] || {term: '', results: [], loading: false, label: null};
                const currentValue = this.state.data[field.name];
                input = (
                    <div className="feature-details-autocomplete">
                        {currentValue &&
                            <div className="feature-details-autocomplete-selected">
                                <span>{autocompleteState.label || currentValue}</span>
                                {!readonly &&
                                    <button className="button" onClick={() => this.clearAutocompleteValue(field)} type="button">×</button>
                                }
                            </div>
                        }
                        {!currentValue && !readonly &&
                            <div className="feature-details-autocomplete-search">
                                <input onChange={ev => this.searchAutocomplete(field, ev.target.value)} placeholder={LocaleUtils.tr("featuredetails.autocompletesearch")}
                                       type="text" value={autocompleteState.term}/>
                                {autocompleteState.loading && <Spinner/>}
                                {autocompleteState.results && autocompleteState.results.length > 0 &&
                                    <ul className="feature-details-autocomplete-results">
                                        {autocompleteState.results.map(item => (
                                            <li key={item.value} onClick={() => this.selectAutocompleteValue(field, item)}>{item.label}</li>
                                        ))}
                                    </ul>
                                }
                            </div>
                        }
                    </div>
                );
                break;
            }
            case 'file':
                input = (
                    <input multiple={false} name={field.name} readOnly={readonly}
                           onChange={ev => this.setFieldValue(field, ev.target.files)} type="file"/>
                );
                break;
            case 'date':
                input = (
                    <input name={field.name} onChange={ev => this.setFieldValue(field, ev.target.value)} type="date"
                           readOnly={readonly}
                           value={this.state.data[field.name] || ''}/>
                );
                break;
            case 'integer':
                input = (
                    <input name={field.name} onChange={ev => this.setFieldValue(field, ev.target.value)} type="number" step="1"
                           readOnly={readonly}
                           value={this.state.data[field.name] || ''}/>
                );
                break;
            case 'decimal':
                input = (
                    <input name={field.name} onChange={ev => this.setFieldValue(field, ev.target.value)} type="number" step="any" inputMode="decimal"
                           readOnly={readonly}
                           value={this.state.data[field.name] || ''}/>
                );
                break;
            case 'text':
            default:
                input = (
                    <input name={field.name} onChange={ev => this.setFieldValue(field, ev.target.value)} type="text"
                           readOnly={readonly}
                           value={this.state.data[field.name] || ''}/>
                );
                break;
        }
        let addon = null;
        if (field.postfix) {
            addon = (
                <div className="feature-details-addon">{field.postfix}</div>
            );
        }
        return (
            <div className="feature-details-field" key={field.name}>
                <label>{field.label}{required && <span className="feature-details-required-marker"> *</span>}</label>
                <div className="feature-details-input">
                    {input}
                    {addon}
                </div>
            </div>
        );
    }

    isFieldRequired(field) {
        let required = true;
        if (field.validate) {
            if (typeof field.validate.required !== 'undefined') {
                required = field.validate.required;
            }
        }
        return required;
    }

    async executeAction(ev) {
        ev.preventDefault();
        if (this.state.uploading) {
            return;
        }

        this.setState({info: ''});
        const emptyFormData = {};

        const filePlaceholders = {};

        // validate
        for (let i = 0; i < this.getConfig().fields.length; i++) {
            const field = this.getConfig().fields[i];
            if (field.type === 'geometry') {
                continue;
            }
            emptyFormData[field.name] = null;

            if (this.isFieldRequired(field) === false) {
                continue;
            }

            if (this.state.data[field.name] == '') {
                this.setState({info: LocaleUtils.tr("featuredetails.missingrequired")});
                return;
            }
            if (field.type == 'file') {
                const filePlaceHolder = '{field.' + field.name + '}';
                filePlaceholders[filePlaceHolder] = field.name;
            }
        }

        // build post data
        const current = this.props.feature;
        const post = cloneDeep(this.getConfig().data);

        let contentType = 'multipart/form-data';
        if (this.getConfig().headers) {
            contentType = this.getConfig().headers['Content-Type'];
        }

        let sendData = null;

        if (contentType && contentType.indexOf('json') > -1) {
            sendData = post;
            const fieldsByName = {};
            this.getConfig().fields.forEach(f => {
                fieldsByName[f.name] = f;
            });
            Object.keys(this.state.data).forEach(k => {
                const value = this.state.data[k];
                const field = fieldsByName[k];
                if (value === '' && field && field.type !== 'text') {
                    // '' is never a valid value for a typed (non-text) field.
                    // - if it started empty and is still empty, the user never touched it: for fields opting
                    //   into omitEmptyValue, leave it out rather than sending an invalid empty value (e.g. for
                    //   a reference/association field, the server may reject '' as "not a valid id")
                    // - if it started with a real value and the user cleared it back to "-", that's a deliberate
                    //   clear: send null (the correct empty representation for a boolean/select/etc, and what
                    //   merge-patch semantics use to mean "remove this value") instead of the invalid ''
                    const initialValue = this.initialData ? this.initialData[k] : undefined;
                    const wasEmpty = initialValue === '' || initialValue === null || typeof initialValue === 'undefined';
                    if (wasEmpty && field.omitEmptyValue) {
                        FeatureUtils.unassign(sendData, k);
                    } else {
                        FeatureUtils.assign(sendData, k, null);
                    }
                } else {
                    FeatureUtils.assign(sendData, k, value);
                }
            });
        } else {
            const fieldData = {
                field: this.state.data
            };
            sendData = new FormData();
            Object.keys(post).forEach(k => {
                let v = post[k];
                if (filePlaceholders[v]) {
                    const dataFileKey = filePlaceholders[v];
                    const file = fieldData.field[dataFileKey];
                    sendData.append(k, file, file.name);
                } else {
                    if (typeof v === 'string') {
                        v = FeatureUtils.prepareUrl(current, v);
                        v = FeatureUtils.genericResolve(fieldData, v);
                    }
                    sendData.append(k, v);
                }
            });
        }

        // send data
        const self = this;
        const url = FeatureUtils.prepareUrl(current, this.getUrl());
        const config = {
            headers: {}
        };
        if (this.getConfig().headers) {
            Object.keys(this.getConfig().headers).forEach(k => {
                config.headers[k] = FeatureUtils.prepareUrl(current, this.getConfig().headers[k]);
            });
        }

        this.setState({uploading: true});

        console.log('Send', url, sendData, config);
        const method = (this.getConfig().method || 'post').toLowerCase();
        let sendAction = null;
        switch (method) {
            case 'get':
                sendAction = axios.get(url, config);
                break;
            case 'post':
                sendAction = axios.post(url, sendData, config);
                break;
            case 'patch':
                sendAction = axios.patch(url, sendData, config);
                break;
            case 'put':
                sendAction = axios.put(url, sendData, config);
                break;
            case 'delete':
                sendAction = axios.delete(url, config);
                break;
        }
        sendAction
            .catch(function (error) {
                console.log('Error sending', error);
                self.triggerError(emptyFormData, error);
            })
            .then(res => {
                this.setState({uploading: false});
                if (typeof res === 'undefined') {
                    self.triggerError(emptyFormData, null);
                } else {
                    self.triggerSuccess(emptyFormData, res.data);
                }
            });
    }

    triggerAction(e, emptyFormData, result) {
        switch (e.type) {
            case 'clear':
                this.setState({data: emptyFormData});
                break;
            case 'message':
                this.setState({info: e.message});
                break;
            case 'opencomponent':
                const url = FeatureUtils.prepareUrl(result, e.url);
                this.openComponentUrl(url);
                break;
            case 'closewindow':
                this.props.removeDetailWindow({id: this.props.windowId});
                break;
            case 'updatefeature':
                this.updateFeature(result);
                break;
        }
    }

    updateFeature(result) {
        if (!result || typeof result !== 'object') {
            return;
        }
        const current = this.props.feature;
        const merged = {
            ...current,
            ...result,
            properties: {
                ...current.properties,
                ...(result.properties || {})
            }
        };
        this.props.setDetailWindow(this.props.windowId, merged, {replace: true});
    }

    triggerSuccess(emptyFormData, result) {
        this.initialData = {...this.state.data};
        this.props.setDirty(this.props.windowId, false);
        if (this.getConfig().success) {
            this.getConfig().success.forEach(e => {
                this.triggerAction(e, emptyFormData, result);
            });
        }
    }

    triggerError(emptyFormData, result) {
        if (this.getConfig().error) {
            this.getConfig().error.forEach(e => {
                this.triggerAction(e, emptyFormData, result);
            });
        }
    }

    renderForm() {
        const label = this.getConfig().buttonLabel || LocaleUtils.tr("featuredetails.upload");
        return (
            <form onSubmit={ev => this.executeAction(ev)}>
                {this.getConfig().fields.map(item => {
                    return this.renderField(item);
                })}
                <div>
                    {this.state.info}
                </div>
                <div>
                    <button className="button">{label}</button>
                </div>
            </form>
        );
    }
}

const selector = () => ({});

export default connect(selector, {
    setDetailWindow: setDetailWindow,
    addDetailWindow: addDetailWindow,
    removeDetailWindow: removeDetailWindow,
    setDirty: setDirty
})(FormTab);
